import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import common, { isMobileScreen, setPageTitle } from "../common";
import ShopNavigationPanel from "./extra/ShopNavigationPanel";

const BlogPage = () => {
  const { slug } = useParams();
  const [content, setContent] = useState("");
  const [imageSrc, setImageSrc] = useState();

  // Set initial title, will be updated when content loads
  setPageTitle(
    `${slug
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase())} | Blog`
  );

  useEffect(() => {
    fetch(
      `https://star-distributors.s3.us-east-1.amazonaws.com/${
        process.env.REACT_APP_IS_PROD === "true" ? "PROD" : "DEV"
      }/blogs/${slug}.html`
    )
      .then((res) => res.text())
      .then((htmlContent) => {
        setContent(htmlContent);

        // Extract title from HTML content if available
        const titleMatch =
          htmlContent.match(/<h1[^>]*>(.*?)<\/h1>/i) ||
          htmlContent.match(/<title[^>]*>(.*?)<\/title>/i);
        if (titleMatch && titleMatch[1]) {
          const cleanTitle = titleMatch[1].replace(/<[^>]*>/g, "").trim();
          setPageTitle(`${cleanTitle} | Hemp & Kratom Blog`);
        } else {
          setPageTitle(
            `${slug
              .replace(/[-_]/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase())} | Blog`
          );
        }
      });

    fetch(
      `https://star-distributors.s3.us-east-1.amazonaws.com/${
        process.env.REACT_APP_IS_PROD === "true" ? "PROD" : "DEV"
      }/blogs/${slug}.png`
    )
      .then((res) => res.blob())
      .then((blob) => {
        if (blob.size <= 1024) {
          setImageSrc(null);
          return;
        }
        const url = URL.createObjectURL(blob);
        setImageSrc(url);
      })
      .catch((error) => {
        console.error("Error fetching blog image:", error);
        setImageSrc(null);
      });
  }, [slug]);

  return (
    <>
      <section
        className="breadcrumbs-custom"
        data-preset='{"title":"Breadcrumbs","category":"header","reload":false,"id":"breadcrumbs"}'
      >
        <div className="breadcrumbs-custom-container">
          <ul className="breadcrumbs-custom-path">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/blogs">Blogs</a>
            </li>
            <li className="active">{slug}</li>
          </ul>
        </div>
      </section>
      <section
        className={isMobileScreen() ? "bg-white" : "section-sm bg-white"}
      >
        <div className="container-xl">
          {isMobileScreen() ? (
            <div>
              {imageSrc && (
                <img
                  className="blog-image mb-3"
                  src={imageSrc}
                  alt=""
                  width="1024"
                  height="400"
                ></img>
              )}
              <div
                className="blog-content mb-4"
                style={{ overflow: "auto", wordBreak: "break-word" }}
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </div>
          ) : (
            <div className="row row-40">
              <div className="col-md-2">
                <ShopNavigationPanel />
              </div>
              <div className="col-md-10">
                {imageSrc && (
                  <img
                    className="blog-image mb-3"
                    src={imageSrc}
                    alt=""
                    width="1024"
                    height="400"
                    style={{ maxHeight: "500px" }}
                  ></img>
                )}
                <div
                  className="blog-content mb-4"
                  style={{ overflow: "auto", wordBreak: "break-word" }}
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default BlogPage;
